import { KindergartenSearchComponent } from "../../../components/form/components/KindergartenSearchComponent";
import { PageHeader } from "../../../components/header/PageHeader";
import { kindergartenSearchForm } from "../../../shared/formObjects/application/kindergartenSearchForm";
import { kindergartenOtherSearchForm } from "../../../shared/formObjects/application/kindergartenOtherSearchForm";
export default function KindergartenCheckerPage() {
  const headerText = [
    {
      class: "p-0 m-0 flex align-center",
      value: "Kindergarten Checker",
      icon: "open-books-icon icon-spec",
    },
  ];

  return (
    <>
      <PageHeader headerText={headerText} hideBreadcrumbs={true} icon={"icon"}></PageHeader>
      <div className="list-table kindergarten-checker">
        <KindergartenSearchComponent
          searchOn="fundedKinderName"
          searchForm={kindergartenSearchForm}
          header="Kindergarten Search"></KindergartenSearchComponent>
        <KindergartenSearchComponent
          searchOn="kindergartenNameOther"
          searchForm={kindergartenOtherSearchForm}
          header="Other Kindergarten Search"></KindergartenSearchComponent>
      </div>
    </>
  );
}
